import React from "react";
import { FaExclamationTriangle, FaTrash, FaTimes } from "react-icons/fa";

function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DeleteDojoModal = ({
  isOpen,
  onClose,
  onConfirm,
  dojoName,
  isSubmitting = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm">
      <div className="w-full max-w-lg overflow-hidden rounded-[28px] border border-white/10 bg-white shadow-2xl dark:border-slate-700 dark:bg-slate-900">
        <div className="border-b border-slate-200 px-6 py-5 dark:border-slate-800">
          <div className="flex items-start gap-4">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-red-100 text-red-600 dark:bg-red-500/10 dark:text-red-300">
              <FaExclamationTriangle className="text-2xl" />
            </div>

            <div>
              <p className="text-sm font-semibold uppercase tracking-wider text-red-600 dark:text-red-400">
                Suppression
              </p>
              <h2 className="mt-1 text-2xl font-black text-slate-900 dark:text-slate-100">
                Confirmer la suppression
              </h2>
            </div>
          </div>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm leading-7 text-slate-700 dark:text-slate-300">
            Vous êtes sur le point de supprimer le lieu{" "}
            <strong>{dojoName || "ce lieu"}</strong>.
            <br />
            Cette action est irréversible et supprimera également les groupes et
            les adhérents associés.
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-end">
            <button
              onClick={onClose}
              className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-300 bg-white px-5 py-3 font-semibold text-slate-800 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:hover:bg-slate-700"
            >
              <FaTimes />
              Annuler
            </button>

            <button
              onClick={onConfirm}
              disabled={isSubmitting}
              className={cn(
                "inline-flex items-center justify-center gap-2 rounded-2xl px-5 py-3 font-semibold text-white transition",
                isSubmitting
                  ? "cursor-not-allowed bg-slate-400 dark:bg-slate-700"
                  : "bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600"
              )}
            >
              <FaTrash />
              {isSubmitting ? "Suppression..." : "Confirmer la suppression"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteDojoModal;